export default __webpack_public_path__ + "3096adbca9ad381132e9ca714ac636d0.svg";